import React, { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Authentication from '../../../libs/api/services/Authentication'
import CommonFunctionsContext from '../../common/CommonFunctionsProvider'
import CalendarComponent from './components/CalendarComponent'

export default function CalendarSection({ filter, calendarType }) {
  const { setAssistantSection } = useContext(CommonFunctionsContext)
  const { id } = useParams()

  const FindCalendarType = () => {
    const Roles = Authentication.getFacilityRoles()
    if (Roles.filter(x => x !== "Patient" && x !== "Client").length === 0)
      return "PATIENT_CALENDAR"
    if (Roles.filter(x => x === "Admin").length > 0)
      if (id)
        return "ADMIN_PATIENT"
      else
        return "ADMIN"
    if (Roles.filter(x => x === "Clinician").length > 0)
      if (id)
        return "CLINICIAN_PATIENT"
      else
        return "CLINICIAN"
    return "ADMIN"
  }

  useEffect(() => {
    setAssistantSection('Calendar')
    return () => { setAssistantSection() }
  }, [])
  return (<CalendarComponent filter={filter} calendarType={FindCalendarType()} patient={id} />)
}
